import React from "react";
import Variable from './AllExportedVariable';
import { GoMarkGithub } from "react-icons/go";
import { FaFacebookF, FaInstagram, FaTelegramPlane, FaLinkedin, FaFileCode, FaPlay, FaRegCalendarAlt } from "react-icons/fa";
import { SiCodesandbox } from "react-icons/si";
import moment from "moment";

export function Promotion() {
    console.log('%c Jika anda memiliki info lowongan kerja, tolong rekrut saya ya. lagi butuh kerjaan hehe. :(( ', 'background: #000; color: #bada55; display:block; padding:5px; font-size:16px;' );
}

export function BrandIcons() {
    return <>
        <div className={Variable.BrandIconsStyle.divStyle}>
            <a className={Variable.BrandIconsStyle.aStyle} href="https://web.facebook.com/bsona1?_rdc=1&_rdr"><span className={Variable.BrandIconsStyle.spanStyle}><FaFacebookF/></span></a>
            <a className={Variable.BrandIconsStyle.aStyle} href="https://www.instagram.com/bagus_sona/"><span className={Variable.BrandIconsStyle.spanStyle}><FaInstagram/></span></a>
            <a className={Variable.BrandIconsStyle.aStyle} href="https://github.com/bagussona"><span className={Variable.BrandIconsStyle.spanStyle}><GoMarkGithub/></span></a>
            <a className={Variable.BrandIconsStyle.aStyle} href="https://t.me/bagussona"><span className={Variable.BrandIconsStyle.spanStyle}><FaTelegramPlane/></span></a>
            <a className={Variable.BrandIconsStyle.aStyle} href="https://www.linkedin.com/in/bagus-sonarangga/"><span className={Variable.BrandIconsStyle.spanStyle}><FaLinkedin/></span></a>
        </div>
    </>
}

export function Contact() {
    return <>
        <div className="flex flex-col sm:flex-row sm:items-center text-slate-300 text-sm font-bold">
            <div className="flex flex-col my-3 md:mr-12 xl:mr-36">
                <span className="text-xs md:text-sm text-slate-400 font-semibold text-left mb-1">Email</span>
                <button className="hover:pl-3 hover:pr-1 pl-1 pr-3 hover:duration-300" onClick={() => window.location = "mailto:bagussona87@gmail.com"} type="button"><span translate="no" className="text-slate-300 text-sm md:text-lg font-bold">bagussona87@gmail.com</span></button>
            </div>
            <div className="flex flex-col my-3 md:ml-12 xl:ml-36">
                <span className="text-xs md:text-sm text-slate-400 font-semibold text-left sm:ml-12 mb-1">Kontak</span>
                <span className="cursor-pointer md:text-lg hover:pl-3 hover:pr-1 pl-1 pr-3 hover:duration-300 sm:ml-12"><a href="tel:+6285712306667">+62 857 1230 6667</a></span>
            </div>
        </div>
    </>
}

export function Divider() {
    return <div className="border-b-4 w-44 my-4"></div>
}

export function Title(props) {
    return <>
        <div className="w-full flex flex-row justify-center items-center">
            <span className="text-3xl md:text-4xl font-bold text-orange-500 mr-1">{props.title}</span>
            <span className="text-3xl md:text-4xl font-bold ml-1">{props.subtitle}</span>
        </div>
    </>
}

export function LabelWebDev() {
    return <>
        <div className="flex flex-row justify-center md:justify-start md:mt-4">
            <div className="date-wrapper flex flex-row mr-3">
                <span className="text-6xl md:text-7xl text-orange-500">24</span>
                <div className="flex flex-row">
                    <span className="text-8xl text-orange-500 ml-1">/</span>
                    <div className="inline-block align-baseline mt-10">
                        <span className="text-6xl md:text-7xl text-orange-500 ml-1">7</span>
                    </div>
                </div>
            </div>
            <div className="dev-wrapper flex flex-col ml-3 mt-5">
                <span className="text-2xl sm:text-3xl md:text-3xl lg:text-3xl xl:text-3xl text-gray-300">WEB DEV</span>
                <span translate="no" className="text-xl sm:text-2xl md:text-2xl lg:text-2xl xl:text-2xl text-gray-300">WANNA BE</span>
            </div>
        </div>
    </>
}

export function Images(props) {
    return <>
        <div className="flex items-center justify-center mt-12 mb-6">
            <img className="object-contain rounded-full h-60 w-60 md:h-80 md:w-80 border-solid border-2 border-white" src={props.data} alt=""/>
        </div>
    </>
}

export function Card(props) {
    const projects = Variable.Projects;

    const filteredArray = projects.filter( obj => obj.title.toLowerCase().indexOf(props.query.toLowerCase()) > -1 );

    return <>
        {filteredArray.map(function(data, index) {
            return <div className="card transition ease-in-out hover:-translate-y-1 hover:scale-100 duration-300 w-[19rem] sm:w-[26rem] md:w-[19rem] xl:w-[22rem] 2xl:w-[26rem] bg-white mx-2 my-2" key={index}>
                <div className="flex flex-col p-4">
                    <div className="flex flex-col mb-6 pb-6 border-b border-slate-200">
                        <h1 className="truncate text-2xl font-bold text-slate-900"><strong>{data.title}</strong></h1>
                        <div className="flex flex-row justify-between items-center py-2 rounded-md space-x-4 text-xs font-light text-slate-600">
                            <div className="flex flex-row">
                                <span className="mx-1"><FaFileCode/></span>
                                <span className="mx-1">{data.env}</span>
                            </div>
                            <div className="flex flex-row">
                                <span className="mx-1"><FaRegCalendarAlt/></span>
                                <span className="mx-1">{moment(data.created_at).format("MMM YYYY")}</span>
                            </div>
                        </div>
                        <p className="truncate flex items-center text-xs text-slate-600 mt-2 w-[17rem] sm:w-[24rem] md:w-[17rem] xl:w-[20rem] 2xl:w-[24rem] h-6 text-justify">{data.description}</p>
                        <div className="flex flex-row justify-end">
                            <span className="flex items-center text-xs text-slate-600 mt-2 h-6 mr-2"><SiCodesandbox /> </span>
                            <p className="flex items-center text-xs text-slate-600 mt-2 h-6 text-justify">{data.framework}</p>
                        </div>
                    </div>
                    <div className="flex flex-row justify-between items-center space-x-4 text-xs font-medium">
                        <div className="flex flex-row items-center">
                            <a className="mx-1" href={data.repoUrl}>
                                <button className="flex flex-row items-center justify-center py-2 px-4 rounded-md bg-slate-800 text-white" type="button">
                                    <span className="mx-1">Lihat</span>
                                    <span className="mx-1"><GoMarkGithub/></span>
                                </button>
                            </a>
                            <a className="mx-1" href={data.demoUrl}>
                                <button className="flex flex-row items-center justify-center py-2 px-4 rounded-md bg-slate-800 text-white" type="button">
                                    <span className="mx-1">Demo</span>
                                    <span className="mx-1"><FaPlay/></span>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        })}
    </>
}

export function Personal(props) {
    return <>
        <div className="w-full my-4">
            <div className="hidden md:flex flex-row w-full greeter mt-12 md:mt-12">
                <span className="text-sm">Halo, saya <span translate="no" className="text-sm">{props.data.name}</span></span>
            </div>
            <LabelWebDev />
            <div className="w-full branding flex flex-col mt-8 md:mt-4">
                <span className="text-sm lg:text-base xl:text-base 2xl:text-base text-gray-300">{props.data.bio}</span>
                <div className="w-full icons mt-6">
                    <BrandIcons />
                </div>
            </div>
        </div>
    </>
}

export function Content(props){
    return <>
        <div className="md:hidden w-full flex flex-row justify-start md:justify-center greeter mt-12">
            <span className="text-sm">Halo, saya <span translate="no" className="text-sm">{props.data.name}</span></span>
        </div>
        <div className="md:w-full md:flex flex-row justify-center items-center md:my-16">
            <div className="images mr-0 md:mr-6 lg:mr-16 xl:mr-20 2xl:mr-24">
                <Images data={props.data.avatar_url} />
            </div>
            <div className="personal mt-12 md:mt-0 ml-0 md:ml-6 lg:ml-16 xl:ml-20 2xl:ml-24">
                <Personal data={props.data} />
            </div>
        </div>
        <div className="minat mt-36 flex flex-col justify-center">
            <div className="flex flex-col justify-center items-center w-full">
                <Title title="Kontak" subtitle="saya" />
                <Divider />
            </div>
            <div className="flex sm:justify-center sm:items-center ml-4 mt-12">
                <Contact />
            </div>
        </div>
    </>
}

export function Footer() {
    return <>
        <div className="w-full flex flex-row justify-between items-center">
            <div className="flex flex-row ml-12 lg:ml-32 xl:ml-52 2xl:ml-80">
                <span className="cursor-pointer mr-2"> Dibuat menggunakan ReactJs, hak cipta &copy; 2022 </span>
                <span className="cursor-pointer hover:pl-3 hover:pr-1 pl-1 pr-3 hover:duration-200 hover:border-b"> <a translate="no" href="https://github.com/bagussona">bagussona</a></span>
            </div>
            <div className="flex flex-row mr-12 lg:mr-32 xl:mr-52 2xl:mr-80">
                <a className="p-0 hover:p-2" href="https://web.facebook.com/bsona1?_rdc=1&_rdr"><span className="flex justify-center items-center mx-2 rounded-full bg-white w-8 h-8 text-black text-lg"><FaFacebookF/></span></a>
                <a className="p-0 hover:p-2" href="https://www.instagram.com/bagus_sona/"><span className="flex justify-center items-center mx-2 rounded-full bg-white w-8 h-8 text-black text-lg"><FaInstagram/></span></a>
                <a className="p-0 hover:p-2" href="https://github.com/bagussona"><span className="flex justify-center items-center mx-2 rounded-full bg-white w-8 h-8 text-black text-lg"><GoMarkGithub/></span></a>
            </div>
        </div>
    </>
}